import { Controller } from "@hotwired/stimulus"

// The Spalten menu (GridTable::ColumnPickerComponent) can list one column under several
// sections — a Zusatzfeld two Vorlagen share. A tick reloads only the table frame, never the
// menu, so the column's other checkboxes are mirrored here or they would show the old state.
export default class extends Controller {
  mirror(event) {
    const { columnKey } = event.target.dataset
    if (!columnKey) return

    this.element.querySelectorAll("input[type=checkbox][data-column-key]").forEach((checkbox) => {
      if (checkbox !== event.target && checkbox.dataset.columnKey === columnKey) {
        checkbox.checked = event.target.checked
      }
    })
  }
}
